/*
User Modify Page
*/
import React, { useEffect, useState } from "react";
import Account from ".//..//..//..//assets//images//icons//account.svg";
import InputTextMat from "../../../components/common/InputText/InputTextMat";
import Button from "../../../components/common/buttons/Button";
import BinIcon from ".//..//..//..//assets//images//icons//bin.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import NotificationDanger from "../../../components/common/Notification/NotificationDanger";
import NotificationSuccess from "../../../components/common/Notification/NotificationSuccess";
import isEmail from "validator/lib/isEmail";
import Swal from "sweetalert2";
import useAuth from "../../../hooks/useAuth";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import InputTextMatPassword from "../../../components/common/InputText/InputTextMatPassword";
import { ToastContainer, toast } from "react-toastify";

const FelhasznaloModsitasa = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const { getAuth } = useAuth();

  const navigate = useNavigate();

  const fetchUser = () => {
    const token = getAuth()?.bearerToken;

    HttpHelper.GetRequest({
      route: API_ROUTES.USER_DATA,
      token: token,
      id: userId,
    })
      .then((data) => {
        const userData = data?.data?.users;
        setEmail(userData.email);
        setName(userData.name);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchUser();
  }, []);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [userCreateError, setUserCreateError] = useState("");
  const [userCreateSuccess, setUserCreateSuccess] = useState("");

  const validateEmail = () => {
    if (email.length < 1) {
      setEmailError("Email is required ");
      return false;
    } else if (!isEmail(email)) {
      setEmailError("Email is Invalid !");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const validateName = () => {
    if (name.trim().length < 1) {
      setNameError("Name is required ");
      return false;
    } else {
      setNameError("");
      return true;
    }
  };

  const updateUser = () => {
    if (validateName() && validateEmail()) {
      setUserCreateError("");
      setUserCreateSuccess("");
      const token = getAuth()?.bearerToken;
      HttpHelper.PutRequest({
        route: API_ROUTES.USER_EDIT,
        token: token,
        id: userId,
        parameters: { name, email },
      })
        .then((res) => {
          if (res === undefined) {
            toast.error("Error, user not updated!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.success("User successfully updated !", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          toast.error("Error, user not updated!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    }
  };

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const updatePassword = () => {
    setPasswordError("");
    setConfirmPasswordError("");
    const token = getAuth()?.bearerToken;
    HttpHelper.PutRequest({
      route: API_ROUTES.USER_PASSWORD_EDIT,
      token: token,
      id: userId,
      parameters: { password, confirmPassword },
    })
      .then((res) => {
        if (res === undefined) {
          toast.error("Error, password not updated!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          if (res.status == 422) {
            const messages = res.message;
            for (const key in messages) {
              if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
                const errorMessage = messages[key][0];
                if (key === "password") {
                  setPasswordError(errorMessage);
                } else if (key === "confirmPassword") {
                  setConfirmPasswordError(errorMessage);
                  setConfirmPassword("");
                }
              }
            }
          } else if (res.status == 200) {
            setPassword("");
            setConfirmPassword("");
            toast.success("Password successfully updated !", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }
      })
      .catch((err) => {
        toast.error("Error, password not updated!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const deleteUser = () => {
    const token = getAuth()?.bearerToken;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#8CD4F5",
        cancelButtonColor: "#eee",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          HttpHelper.DeleteRequest({
            route: API_ROUTES.USER_DELETE,
            id: userId,
            token: token,
          })
            .then((data) => {
              navigate(ROUTES.ADMIN_USERS);

              toast.success("User successfully removed !", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            })
            .catch((error) => {});
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Your imaginary file is safe :)",
            icon: "error",
          });
        }
      });
  };

  return (
    <>
      <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem]  flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
        <Link to={ROUTES.ADMIN_USERS}>
          <img src={Account} alt="account icon" className="w-[3rem] sm:w-[4.35rem] " />
        </Link>

        <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Felhasználók</h2>
      </div>

      <div className="mt-[3rem] flex flex-col lg:flex-row  gap-12 ">
        {/* Form  - User New User */}
        <div className="lg:order-2 order-1 px-[1rem] sm:px-[1.875rem] overflow-x-auto w-full lg:w-1/2  lg:mt-[7.6rem]">
          <div className="flex flex-row items-end justify-between">
            <h3 className="text-text-primary-color text-[1.5rem] font-bold">Felhasználói adatok módosítása</h3>
            <img src={BinIcon} onClick={deleteUser} className="cursor-pointer h-7 w-7" />
          </div>
          <div className="flex flex-col gap-[1.6rem] my-[2.5rem] mb-0">
            <InputTextMat
              label={"Név"}
              id={`name`}
              value={name}
              name={nameError}
              onChange={(e) => setName(e.target.value)}
            />
            <InputTextMat
              id={`email`}
              label={"Email"}
              value={email}
              error={emailError}
              readOnly={true}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {userCreateError && <NotificationDanger message={userCreateError} />}
          {userCreateSuccess && <NotificationSuccess message={userCreateSuccess} />}
          <div className="text-end">
            <Button label={`Mentés`} onClick={updateUser} />
          </div>
        </div>
        {/* Form - User Password */}
        <div className="lg:order-2 order-1 px-[1rem] sm:px-[1.875rem] overflow-x-auto w-full lg:w-1/2  lg:mt-[7.6rem]">
          <div className="flex flex-row items-end justify-between">
            <h3 className="text-text-primary-color text-[1.5rem] font-bold">A jelszó módosítása</h3>
          </div>
          <div className="flex flex-col gap-[1.6rem] my-[2.5rem] mb-0">
            <InputTextMatPassword
              label={"Jelszó"}
              id={`password`}
              value={password}
              name={`password`}
              error={passwordError}
              onChange={(e) => setPassword(e.target.value)}
            />
            <InputTextMatPassword
              id={`confirmPassword`}
              label={"Jelszó megerősítése"}
              value={confirmPassword}
              error={confirmPasswordError}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          {userCreateError && <NotificationDanger message={userCreateError} />}
          {userCreateSuccess && <NotificationSuccess message={userCreateSuccess} />}
          <div className="text-end">
            <Button label={`Mentés jelszó`} onClick={updatePassword} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FelhasznaloModsitasa;
